import { Box, styled } from '@mui/material';
import { revaluation as rules } from 'further-ui/validations';
import React from 'react';
import { Vehicle } from 'further-types/lp/vehicle';
import processRevaluationHistory from '../../../helpers/processRevaluationHistory';
import getLatestRevaluationsForEachHoldingClass from '../../helpers/getLatestRevaluationsForEachHoldingClass';
import RevaluationHistoryTable from '../../RevaluationHistoryTable';

type Props = {
  savedData: rules.RevaluationFormType;
  vehicle: Vehicle;
};

const PaddedContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.sm),
}));

const CompanyRevaluationHistorySection: React.FC<Props> = ({
  savedData,
  vehicle,
}) => {
  const globalFxRate = savedData.revaluationCurrencyRates?.global ?? null;

  const allRevaluations = [
    ...(savedData.revaluations ?? []),
    ...(savedData.newRevaluations ?? []).filter((r) => !r.isRemoved),
  ];

  const revaluationHistory = processRevaluationHistory(allRevaluations);

  const latestRevaluationsWithChanges =
    getLatestRevaluationsForEachHoldingClass(revaluationHistory).filter(
      (rev) =>
        rev.isNew &&
        (rev.hasChange ||
          (rev.currency !== vehicle.baseCurrency && !!globalFxRate)),
    );

  return (
    <PaddedContent>
      <RevaluationHistoryTable
        revaluations={latestRevaluationsWithChanges}
        removeColumns={[
          'date',
          'function',
          'type',
          'valuationChangePercentage',
        ]}
      />
    </PaddedContent>
  );
};

export default CompanyRevaluationHistorySection;
